import {Moment} from 'moment';

export type TimeRegType = (typeof TIME_REG_TYPES)[keyof typeof TIME_REG_TYPES];
export const TIME_REG_TYPES = {
	TASK_TIME: 'taskTime',
	PROJECT_TIME: 'projectTime',
	IDLE_TIME: 'idleTime',
	NO_ACCESS: 'noAccess',
} as const;

export const buildWeekArr = (endDate: Moment): Moment[] => {
	const rec = (date: Moment, depth: number) => {
		return depth > 0 ? [...rec(date.clone().subtract(1, 'days'), depth - 1), date] : [];
	};
	return rec(endDate.clone(), 7);
};
